import { useState } from 'react'

import { Tabs, TabsList, TabsTrigger } from '@/components/ui/tabs'
import { type SalesLead } from '@/models/salesLead'
import { LeadCarrierCard } from './LeadCarrierCard'

interface CarriersTabProps {
  lead: SalesLead
}

export function CarriersTab({ lead }: CarriersTabProps) {
  const assignedCarriers = lead.assignedCarriers
  const [activeId, setActiveId] = useState<string | null>(null)

  if (assignedCarriers.length === 0) {
    return (
      <p className="text-muted-foreground py-2 text-sm">
        No carriers assigned yet. Use the Carriers picker in the sidebar to assign one or more.
      </p>
    )
  }

  // Keep the selection valid when carriers are added/removed from the sidebar.
  const selectedId =
    activeId && assignedCarriers.some((c) => c.id === activeId) ? activeId : assignedCarriers[0].id
  const selectedCarrier = assignedCarriers.find((c) => c.id === selectedId)!

  return (
    <div className="flex flex-col gap-4 py-2">
      <Tabs value={selectedId} onValueChange={setActiveId}>
        <TabsList variant="line" className="flex-wrap">
          {assignedCarriers.map((carrier) => (
            <TabsTrigger key={carrier.id} value={carrier.id}>
              {carrier.logo && <img src={carrier.logo} alt="" className="size-4 rounded object-contain" />}
              {carrier.name}
            </TabsTrigger>
          ))}
        </TabsList>
      </Tabs>

      {/* key by carrier so composer/reply draft state doesn't leak across tabs */}
      <LeadCarrierCard key={selectedId} lead={lead} carrier={selectedCarrier} />
    </div>
  )
}
